export default __webpack_public_path__ + "static/media/english-to-spanish-screenshot-02.08b27040.png";